export const setUrlQueryParam = (url: URL, key: string, value: string | boolean | undefined): void => {
    if (value === undefined) {
        return;
    }

    url.searchParams.set(key, String(value));
};
